import React from 'react';
import { Button } from '@ds/ui';
import { BannerInfo } from '../../types/BannerInfo';
import { apiFetch, handleApiError } from '../../utils/apiClient';

interface ImportDPUKeyProps {
  onBannerUpdate: (bannerInfo: BannerInfo | null) => void;
}

interface ErrorResponse {
  Error: string;
  ErrorType: string;
}

export default function ImportDPUKey({ onBannerUpdate }: ImportDPUKeyProps) {
  const handleImportDPU = async () => {
    try {
      const response = await apiFetch('Admin/Home/ImportDPU', {
        method: 'GET'
      });
      
      if (!response.ok) {
        await handleApiError(response);
      }

      const data = await response.json();
      onBannerUpdate({ 
        type: 'success', 
        message: data.message || 'DPU Key imported successfully' 
      });
    } catch (error) {
      console.error('Error importing DPU key:', error);
      onBannerUpdate({ 
        type: 'danger', 
        message: error instanceof Error ? error.message : 'Failed to import DPU key', 
        retryAction: handleImportDPU 
      });
    }
  };

  return (
    <Button
      text="Import DPU Key"
      kind="secondary"
      onClick={handleImportDPU}
    />
  );
}